import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Fees`}</h2>
    <p>{`I will visit on any schedule you would like.  Each visit is $10, with $2 for each additional dog in your household.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      